<template>
  <div>
    <!-- Popup -->
    <vs-popup :title="`${action_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <div class="vx-row mb-2">
              <label class="vs-input--label">User Name: </label>
              <label class="vs-input--label ml-1">{{ data.first_name }} {{ data.last_name }}</label>
            </div>

            <!-- Creator -->
            <div class="vx-row mb-2">
              <label class="vs-input--label">Creator *</label>
              <select-2
                class="w-full category-input"
                name="Creator"
                placeholder="Select Creator"
                :value="form.creator"
                @input="(item) => (form.creator = item && item.value)"
                autocomplete
                :ssr="true"
                :multiple="false"
                v-validate="'required'"
                action="creator/get"
                :options="creator"
                :params="{ creatorIds: JSON.stringify(form.creator), creator_type: 'Artist' }"
                data-vv-as="Creator"
              />
              <span class="text-danger text-sm" v-show="errors.has('Creator')">{{ errors.first('Creator') }}</span>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="assign-artist" @click="save_changes">{{ action_name }}</vs-button>
              <vs-button color="danger" class="text-left" @click="cancelPopup">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: `assignArtist`,

  /** components */
  components: {
    Select2
  },

  /** Props */
  props: {
    showModal: Boolean,
    data: Object,
    module_name: String,
    action_name: String
  },

  /** data */
  data() {
    return {
      form: {
        creator: ''
      },
      creator: []
    }
  },

  /** created */
  async created() {
    if (this.data) {
      this.form.creator = this.data.creator ? this.data.creator._id : ''
    }
    const { data } = await this.getDropdownCreators({ creator_type: 'Artist' })

    this.creator = data.results.map((value) => {
      return {
        value: value._id,
        label: value.name
      }
    })
  },
  /** computed */
  computed: {
    ...mapState('creator', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** methods */
  methods: {
    ...mapActions('creator', {
      assignArtist: 'assignArtist'
    }),
    ...mapActions('common', {
      getDropdownCreators: 'getDropdownCreators'
    }),

    cancelPopup() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.data && !this.form.thumbnail) {
        this.$vs.notify({
          title: 'Error',
          text: 'Thumbnail Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      // if (!this.data && !this.form.image) {
      //   this.$vs.notify({
      //     title: 'Error',
      //     text: 'Image Is Required!',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     position: 'top-center',
      //     time: 5000,
      //     color: 'primary'
      //   })
      //   return false
      // }
      try {
        const result = await this.assignArtist({ creator: this.form.creator, user: this.data._id })
        const message = result.message
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.isActive = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#assign-artist',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#assign-artist > .con-vs-loading')
      }
    }
  }
}
</script>
